import React, { useState, useRef } from 'react';
import DateSelector from 'components/molecules/dateSelector/range';
import CrossStitchIcon from 'components/atoms/icons/crossStitchIcon';
import useOutsideClick from 'utils/useOutsideClick';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';

const DateInput = ({ date, onSelect, onClear, readOnly: disabled }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const ref = useRef();

  useOutsideClick(ref, () => {
    setShowDatePicker(false);
  });

  return (
    <div className="medication-table-date">
      <div ref={ref}>
        <div
          onClick={() => setShowDatePicker(true)}
          className="editable-row__date"
        >
          <Input
            readOnly
            style={{ outline: 'none' }}
            plaintext
            bsSize="sm"
            value={date === null ? '' : date}
            onChange={() => {}}
          />
        </div>
        {showDatePicker && !disabled && (
          <div className="datepicker">
            <DateSelector
              onSelect={(e) => {
                onSelect(e);
                setShowDatePicker(false);
              }}
            />
          </div>
        )}
      </div>
      {date && !disabled && (
        <button onClick={onClear} className="editable-row__date-clear-btn">
          <CrossStitchIcon />
        </button>
      )}
    </div>
  );
};

DateInput.defaultProps = {
  onSelect: () => {},
  onClear: () => {},
};

DateInput.propTypes = {
  date: PropTypes.string,
  onSelect: PropTypes.func,
  onClear: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default DateInput;
